import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../design";

const RentMonthPaidModal = (props) => {
  const { handleClose, handleContinue, show } = props;
  const { _t } = useTranslator();
  return (
    <Modal
      open={show}
      onClose={handleClose}
      size="sm"
      title={_t("rentAlreadyPaid")}
      description={_t(
        "rentForSelectedMonthIsAlreadyPaidAreYouSureYouWantToContinue"
      )}
      actions={
        <>
          <Button variant="secondary" size="lg" onClick={handleClose}>
            {_t("goBack")}
          </Button>
          <Button size="lg" onClick={handleContinue}>
            {_t("continue")}
          </Button>
        </>
      }
    />
  );
};

export default RentMonthPaidModal;
